import React from "react";
import UserOnlineStatus from "../../../../UserOnlineStatus";
import { calculateTotalAmount } from "../helpers";
import { TargetAmount, TradeLimits, TradeRate } from "../../../TradeIcons";
import { abbreviateNumber } from "../helpers";
import { getRating, getTotalRating } from "../../../Offers/AllOffers/helpers";
import { t } from "../../../../../utils/i18n";

const Rate = ({ offer, sellerRate, offerTypeDisplay, reviews }) => {

  const calculateMinUSD = () => {
    const tradeRate = Number(offer?.tradeRate);
    const rangeMin = Number(offer?.rangeMin);
  
    const result = tradeRate !== 0 ? rangeMin / tradeRate : 0;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(result || 0);
  };
  
  const calculateMaxUSD = () => {
    const tradeRate = Number(offer?.tradeRate);
    const rangeMax = Number(offer?.rangeMax);
  
    const result = tradeRate !== 0 ? rangeMax / tradeRate : 0;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(result || 0);
  };
  
  return (
    <div>
      <div className="createtrade-about-profile">
        <div>
          <div className="container">
            <div className="row">
              <div className="about-trader">
                <div className="about-traderprofile-section">
                  <div>
                    <small
                      className={`broker-details-heading ${offerTypeDisplay === 'sell' ? 'createtrade-sell' : 'createtrade-buy'}`}>
                      {t("p2p.rate.broker_details")}
                    </small>
                    <div className="createtrade-about-profile-details">
                      <div className="createtrade-about-profile-name">
                        <p title={`${offer.customOfferLabel}`}>
                          <a href={`/profile/${offer.profile?.userName}`} className="createtrade-profilename" target="_blank" rel="noopener noreferrer">
                          <i className="fa fa-user-circle"></i>{" "}
                          {offer.customOfferLabel
                          ? `${offer.customOfferLabel.slice(0, 15)}${offer.customOfferLabel.length > 15 ? '...' : ''}`
                          : '...'}{" "}
                          </a>
                          <i title={t("p2p.hit.verified")} className="fa fa-check-circle" style={{ color: "#f79236" }}></i>
                        </p>
                      </div>
                      <div className="createtrade-online">
                        {offer.userId && (
                          <UserOnlineStatus
                            userId={offer.userId}
                            online={offer.online}
                            lastSeenAt={offer.lastSeenAt}
                          />
                        )}
                      </div>
                    </div> 
                  </div>

                  {/* Profile details */}
                  <div className="createtrade-profiledetails-section">
                    <div className="profile-more-details">
                      <>
                        <span title={t("p2p.hit.total_trades_tip")}>{t("p2p.hit.trades", { count: abbreviateNumber(offer?.profile?.totalTrades || 0) })}</span>
                        <span className="offer-profiledetails-divider">&nbsp;|&nbsp;</span>
                        <span title={t("p2p.hit.rating_tip")}>
                          <i className="fa fa-thumbs-up profiledetails-icon"></i>&nbsp;
                          {`${getRating(offer?.profile?.id,reviews)}`}
                          <span className="offer-profiledetails-divider">&nbsp;|&nbsp;</span>
                        </span>

                        <span title={t("p2p.rate.reviews_tip")}>
                           <i className="fa fa-comments profiledetails-icon"></i> {t("p2p.hit.reviews")}
                           {`${getTotalRating(offer?.profile?.id,reviews)}`}
                           <span className="offer-profiledetails-divider">&nbsp;|&nbsp;</span>
                        </span>

                        <span title={t("p2p.hit.time_tip")}>
                          <i className="fa fa-stopwatch profiledetails-icon"></i> {t("p2p.hit.thirty")}
                        </span>
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div>
            <div>
              <div className="rate-and-limits-cont">
                <div className="rate-and-limits">
                  <div className="rate-and-limits-sections" title={t("p2p.rate.price_tip")}>
                    <span>
                      <TradeRate />
                    </span>
                    <h4 className="text-muted leading-normal font-1_3">
                      {t("p2p.rate.trade")}
                    </h4>
                    <h4 className="text-muted leading-normal font-1_3">
                      {t("p2p.rate.rate")}
                    </h4>
                    <span className="font-1_1 font-weight-bold">
                      {new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        parseFloat(sellerRate || "0")
                      )}{" "}
                      {offer.fiatCurrency?.code}
                    </span>
                  </div>
                  
                  <div className="rate-and-limits-sections" title={t("p2p.rate.target_tip")}>
                    <span>
                      <TargetAmount />
                    </span>
                    <h4 className="text-muted leading-normal font-1_3">
                      {t("p2p.rate.target")}
                    </h4>
                    <h4 className="text-muted leading-normal font-1_3">
                      {t("p2p.rate.amount")}
                    </h4>
                    <span className="font-1_1 font-weight-bold">
                      {new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        parseFloat(offer.availableAmount || "0")
                      )}{" "}
                      USD
                    </span>
                  </div>

                  <div className="rate-and-limits-sections" title={t("p2p.rate.limits_tip")}>
                    <span>
                      <TradeLimits />
                    </span>
                    <h4 className="text-muted leading-normal font-1_3 text-capitalize">
                      {t("p2p.rate.limits")}
                    </h4>
                    <p className="rate-and-limit-minmax">
                      <span>
                        <span className="rate-and-limit-minmax-title">
                          {t("p2p.hit.min")}{" "}
                        </span>
                        <span className="font-weight-bold">
                        {new Intl.NumberFormat('en-US', {
                          style: 'decimal',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(offer?.rangeMin || 0)}
                        </span>
                        <span className="font-weight-bold">
                          {" "}
                          {offer.fiatCurrency?.code}
                        </span>
                        <span>
                          {" "}
                          (
                            {calculateMinUSD() || "" }
                          )
                        </span>
                      </span>
                      <span>
                        <span className="rate-and-limit-minmax-title">
                          {t("p2p.hit.max")}{" "}
                        </span>
                        <span className="font-weight-bold">
                          {new Intl.NumberFormat('en-US', {
                            style: 'decimal',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(offer?.rangeMax || 0)}
                        </span>
                        <span className="font-weight-bold">
                          {" "}
                          {offer.fiatCurrency?.code}
                        </span>
                        <span>
                          {" "}
                          (
                            {calculateMaxUSD()}
                          )
                        </span>
                      </span>
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rate;
